module.exports = __webpack_public_path__ + "static/img/wanted3.49c1800.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/wanted3.png
// module id = e6L2
// module chunks = 1 3